const PRODUCT_ALIASES = {
  'gf-bodykit-front-bumper-lip-2025-2026-toyota-camry-se-xse':
    'gf-3-piece-front-bumper-lip-for-2025-2026-toyota-camry-se-xse',
  'low-profile-side-window-visors-2025-2026-toyota-camry':
    'krvn-premium-window-visors-for-2025-2026-toyota-camry',
  'gf-bodykit-side-skirt-extensions-2025-2026-toyota-camry':
    'gf-bodykit-2-piece-side-skirt-extensions-for-2025-2026-toyota-camry',
  'gloss-black-door-handle-covers-2025-2026-toyota-camry':
    'krvn-gloss-black-door-handle-covers-for-2025-2026-toyota-camry',
};

function productHandle(anchor) {
  try {
    const handle = new URL(anchor.href, window.location.origin).pathname.match(/^\/products\/([^/]+)/)?.[1];
    return handle ? PRODUCT_ALIASES[handle] || handle : '';
  } catch (_error) {
    return '';
  }
}

function money(cents, currency = 'USD') {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents || 0) / 100);
  } catch (_error) {
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }
}

function productImage(value) {
  if (!value) return '';
  try {
    const url = new URL(value, window.location.origin);
    url.searchParams.set('width', '480');
    return url.toString();
  } catch (_error) {
    return value;
  }
}

function createCard(item, product) {
  const card = document.createElement('a');
  card.className = 'kraven-guide-product';
  card.href = `/products/${item.handle}`;
  card.setAttribute('aria-label', `View ${product.title || item.label}`);

  const media = document.createElement('span');
  media.className = 'kraven-guide-product__media';
  const image = product.featured_image || product.images?.[0];
  if (image) {
    const img = document.createElement('img');
    img.src = productImage(image);
    img.alt = product.title || item.label;
    img.loading = 'lazy';
    img.decoding = 'async';
    media.append(img);
  }

  const copy = document.createElement('span');
  copy.className = 'kraven-guide-product__copy';
  const eyebrow = document.createElement('small');
  eyebrow.textContent = item.intent === 'compare' ? 'Compare this option' : 'Complete the build';
  const title = document.createElement('strong');
  title.textContent = product.title || item.label;
  const action = document.createElement('span');
  action.textContent = `${money(product.price, window.Shopify?.currency?.active || 'USD')} · View option`;
  copy.append(eyebrow, title, action);
  card.append(media, copy);
  return card;
}

async function hydrateGuideProducts(section) {
  if (section.dataset.guideProductsReady === 'true') return;

  const description = section.querySelector('.kraven-technical__guide-content');
  const shelf = section.querySelector('[data-guide-products]');
  const compareGroup = section.querySelector('[data-guide-compare]');
  const compareTrack = section.querySelector('[data-guide-compare-track]');
  const completeGroup = section.querySelector('[data-guide-complete]');
  const completeTrack = section.querySelector('[data-guide-complete-track]');
  if (!description || !shelf || !compareGroup || !compareTrack || !completeGroup || !completeTrack) return;

  const currentHandle = window.location.pathname.match(/^\/products\/([^/]+)/)?.[1] || '';
  const seen = new Set();
  const products = [];
  let activeIntent = 'complete';

  description.querySelectorAll('h2,h3,h4,a[href*="/products/"]').forEach((node) => {
    if (/^H[2-4]$/.test(node.tagName)) {
      const heading = node.textContent.toLowerCase();
      if (/compare|choose.*option|alternatives?|other.*option|vs\.?|versus/.test(heading)) activeIntent = 'compare';
      else if (/complete|pair with|finish.*build|build.*with|add.*build/.test(heading)) activeIntent = 'complete';
      return;
    }

    const handle = productHandle(node);
    if (!handle || handle === currentHandle || seen.has(handle)) return;
    seen.add(handle);
    products.push({ handle, label: node.textContent.trim(), intent: activeIntent });
  });

  if (!products.length) return;
  section.dataset.guideProductsReady = 'true';

  const results = await Promise.all(
    products.slice(0, 6).map(async (item) => {
      try {
        const response = await fetch(`/products/${item.handle}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        return { item, product: await response.json() };
      } catch (_error) {
        return null;
      }
    })
  );

  results.filter(Boolean).forEach(({ item, product }) => {
    const card = createCard(item, product);
    if (item.intent === 'compare') {
      compareTrack.append(card);
      compareGroup.hidden = false;
    } else {
      completeTrack.append(card);
      completeGroup.hidden = false;
    }
  });

  if (!compareGroup.hidden || !completeGroup.hidden) shelf.hidden = false;
}

function connect(section) {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        hydrateGuideProducts(section);
      },
      { rootMargin: '500px 0px' }
    );
    observer.observe(section);
  } else {
    hydrateGuideProducts(section);
  }
}

document.querySelectorAll('.kraven-technical').forEach(connect);
